function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
Object.defineProperty(exports, '__esModule', {
    value: true
});
var React = require('react');
var useSWR = require('../index/index.js');
var index_js = require('../_internal/index.js');
function _interopDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
var React__default = /*#__PURE__*/ _interopDefault(React);
var useSWR__default = /*#__PURE__*/ _interopDefault(useSWR);
var startTransition = index_js.IS_REACT_LEGACY ? function(cb) {
    cb();
} : React__default.default.startTransition;
/**
 * An implementation of state with dependency-tracking.
 * @param initialState - The initial state object.
 */ var useStateWithDeps = function(initialState) {
    var _React_useState = _sliced_to_array(React.useState({}), 2), rerender = _React_useState[1];
    var unmountedRef = React.useRef(false);
    var stateRef = React.useRef(initialState);
    // If a state property (data, error, or isValidating) is accessed by the render
    // function, we mark the property as a dependency so if it is updated again
    // in the future, we trigger a rerender.
    // This is also known as dependency-tracking.
    var stateDependenciesRef = React.useRef({
        data: false,
        error: false,
        isValidating: false
    });
    /**
   * Updates state and triggers re-render if necessary.
   * @param payload To change stateRef, pass the values explicitly to setState:
   * @example
   * ```js
   * setState({
   *   isValidating: false
   *   data: newData // set data to newData
   *   error: undefined // set error to undefined
   * })
   *
   * setState({
   *   isValidating: false
   *   data: undefined // set data to undefined
   *   error: err // set error to err
   * })
   * ```
   */ var setState = React.useCallback(function(payload) {
        var shouldRerender = false;
        var currentState = stateRef.current;
        for(var key in payload){
            if (Object.prototype.hasOwnProperty.call(payload, key)) {
                var k = key;
                // If the property has changed, update the state and mark rerender as
                // needed.
                if (currentState[k] !== payload[k]) {
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    currentState[k] = payload[k];
                    // If the property is accessed by the component, a rerender should be
                    // triggered.
                    if (stateDependenciesRef.current[k]) {
                        shouldRerender = true;
                    }
                }
            }
        }
        if (shouldRerender && !unmountedRef.current) {
            rerender({});
        }
    }, []);
    index_js.useIsomorphicLayoutEffect(function() {
        unmountedRef.current = false;
        return function() {
            unmountedRef.current = true;
        };
    });
    return [
        stateRef,
        stateDependenciesRef.current,
        setState
    ];
};
var mutation = function() {
    return function(key, fetcher) {
        var config = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
        var mutate = useSWR.useSWRConfig().mutate;
        var keyRef = React.useRef(key);
        var fetcherRef = React.useRef(fetcher);
        var configRef = React.useRef(config);
        // Ditch all mutation results that happened earlier than this timestamp.
        var ditchMutationsUntilRef = React.useRef(0);
        var _useStateWithDeps = _sliced_to_array(useStateWithDeps({
            data: index_js.UNDEFINED,
            error: index_js.UNDEFINED,
            isMutating: false
        }), 3), stateRef = _useStateWithDeps[0], stateDependencies = _useStateWithDeps[1], setState = _useStateWithDeps[2];
        var currentState = stateRef.current;
        var trigger = React.useCallback(/*#__PURE__*/ function() {
            var _ref = _async_to_generator(function(arg, opts) {
                var _index_js_serialize, serializedKey, resolvedKey, options, mutationStartedAt, data, error;
                return _ts_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _index_js_serialize = _sliced_to_array(index_js.serialize(keyRef.current), 2), serializedKey = _index_js_serialize[0], resolvedKey = _index_js_serialize[1];
                            if (!fetcherRef.current) {
                                throw new Error('Can’t trigger the mutation: missing fetcher.');
                            }
                            if (!serializedKey) {
                                throw new Error('Can’t trigger the mutation: missing key.');
                            }
                            // Disable cache population by default.
                            options = index_js.mergeObjects(index_js.mergeObjects({
                                populateCache: false,
                                throwOnError: true
                            }, configRef.current), opts);
                            // Trigger a mutation, and also track the timestamp. Any mutation that happened
                            // earlier this timestamp should be ignored.
                            mutationStartedAt = index_js.getTimestamp();
                            ditchMutationsUntilRef.current = mutationStartedAt;
                            setState({
                                isMutating: true
                            });
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                3,
                                ,
                                4
                            ]);
                            return [
                                4,
                                mutate(serializedKey, fetcherRef.current(resolvedKey, {
                                    arg: arg
                                }), index_js.mergeObjects(options, {
                                    throwOnError: true
                                }))
                            ];
                        case 2:
                            data = _state.sent();
                            // If it's reset after the mutation, we don't broadcast any state change.
                            if (ditchMutationsUntilRef.current <= mutationStartedAt) {
                                startTransition(function() {
                                    return setState({
                                        data: data,
                                        isMutating: false,
                                        error: undefined
                                    });
                                });
                                options.onSuccess == null ? void 0 : options.onSuccess.call(options, data, serializedKey, options);
                            }
                            return [
                                2,
                                data
                            ];
                        case 3:
                            error = _state.sent();
                            // If it's reset after the mutation, we don't broadcast any state change
                            // or throw because it's discarded.
                            if (ditchMutationsUntilRef.current <= mutationStartedAt) {
                                startTransition(function() {
                                    return setState({
                                        error: error,
                                        isMutating: false
                                    });
                                });
                                options.onError == null ? undefined : options.onError.call(options, error, serializedKey, options);
                                if (options.throwOnError) {
                                    throw error;
                                }
                            }
                            return [
                                3,
                                4
                            ];
                        case 4:
                            return [
                                2
                            ];
                    }
                });
            });
            return function(arg, opts) {
                return _ref.apply(this, arguments);
            };
        }(), []);
        var reset = React.useCallback(function() {
            ditchMutationsUntilRef.current = index_js.getTimestamp();
            setState({
                data: index_js.UNDEFINED,
                error: index_js.UNDEFINED,
                isMutating: false
            });
        // eslint-disable-next-line react-hooks/exhaustive-deps
        }, []);
        index_js.useIsomorphicLayoutEffect(function() {
            keyRef.current = key;
            fetcherRef.current = fetcher;
            configRef.current = config;
        });
        // We don't return `mutate` here as it can be pretty confusing (e.g. people
        // calling `mutate` but they actually mean `trigger`).
        // And also, `mutate` relies on the useSWR hook to exist too.
        return {
            trigger: trigger,
            reset: reset,
            get data () {
                stateDependencies.data = true;
                return currentState.data;
            },
            get error () {
                stateDependencies.error = true;
                return currentState.error;
            },
            get isMutating () {
                stateDependencies.isMutating = true;
                return currentState.isMutating;
            }
        };
    };
};
/**
 * A hook to define and manually trigger remote mutations like POST, PUT, DELETE and PATCH use cases.
 *
 * @link https://swr.vercel.app/docs/mutation
 * @example
 * ```jsx
 * import useSWRMutation from 'swr/mutation'
 *
 * const {
 *   data,
 *   error,
 *   trigger,
 *   reset,
 *   isMutating
 * } = useSWRMutation(key, fetcher, options?)
 * ```
 */ var useSWRMutation = index_js.withMiddleware(useSWR__default.default, mutation);
exports.default = useSWRMutation;
